module.exports = __webpack_public_path__ + "img/dynamic-23.352e34f4.png";